import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mailbox',
  templateUrl: './mailbox.component.html',
  styleUrls: ['./mailbox.component.sass']
})
export class MailboxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
